const development = (process.env.NODE_ENV === 'development' && process.env.PUBLIC_URL === '');
export default {
  apiKey: 'AIzaSyB6HsdnwYA2ofYnCx_VFLahyORDNKg2sFY',
  authDomain: 'vase-qbank.firebaseapp.com',
  databaseURL: 'https://vase-qbank.firebaseio.com',
  projectId: 'vase-qbank',
  storageBucket: 'vase-qbank.appspot.com',
  messagingSenderId: '16982613517',
  firebaseQuestionsPath: (development === true) ? 'dev-questions-NEW-2/': process.env.REACT_APP_PROD_QUESTION_DB_KEY,
  firebaseProjectsPath: (development === true) ? 'dev-projects/': process.env.REACT_APP_PROD_PROJECT_DB_KEY,
  endpointExport: (development === true) ? "https://us-central1-vase-qbank.cloudfunctions.net/app": process.env.REACT_APP_PROD_ENDPOINT_EXPORT,
  log: {
    path: 'log',
    ACTION_REMOVE_QUESTION: "remove_question"
  },
  realtime_site: (development === true) ? 'false' : process.env.REACT_APP_PROD_REALTIME_SITE,
}

console.log('global configuration: ', {
  firebaseQuestionsPath: (development === true) ? 'dev-questions/': process.env.REACT_APP_PROD_QUESTION_DB_KEY,
  firebaseProjectsPath: (development === true) ? 'dev-projects/': process.env.REACT_APP_PROD_PROJECT_DB_KEY,
  endpointExport: (development === true) ? "https://us-central1-vase-qbank.cloudfunctions.net/app": process.env.REACT_APP_PROD_ENDPOINT_EXPORT
})




// WEBPACK FOOTER //
// ./src/config/index.js